<script setup lang="ts">
import Icon from "./Icon.vue";

export interface TimelineItem {
  time: string;
  icon: string;
  title: string;
  detail?: string;
  /** `next` is the emphasised one; `done` is behind you; `upcoming` is muted. */
  state?: "next" | "done" | "upcoming";
}

defineProps<{ items: TimelineItem[] }>();
</script>
<template>
  <div class="cw-timeline">
    <div
      v-for="(it, i) in items"
      :key="`${it.time}-${i}`"
      class="cw-timeline__row"
    >
      <span class="cw-timeline__time">{{ it.time }}</span>
      <span class="cw-timeline__rail">
        <span
          v-if="i < items.length - 1"
          class="cw-timeline__line"
        />
        <span
          class="cw-timeline__dot"
          :class="{
            'cw-timeline__dot--done': it.state === 'done',
            'cw-timeline__dot--muted': it.state === 'upcoming',
          }"
        />
      </span>
      <div class="cw-timeline__body">
        <div class="cw-timeline__title">
          <Icon
            :name="it.icon"
            :size="15"
          />
          {{ it.title }}
        </div>
        <div
          v-if="it.detail"
          class="cw-timeline__sub"
        >
          {{ it.detail }}
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.cw-timeline__title { display: flex; align-items: center; gap: var(--space-4); }
</style>
